import styled, { css } from "styled-components";

import { fadeIn } from "@pages/casino/assets/styles/animations";

const commonFlexStyles = css`
	display: flex;
	align-items: center;
`;

const commonAnimationStyles = css`
	animation: ${fadeIn} 0.3s ease-in;
	animation-fill-mode: forwards;
`;

const commonModalItemStyles = css`
	display: flex;
	flex-direction: column;
`;

export const ModalWrapper = styled.div`
	position: fixed;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
	align-items: center;
	display: ${(props) => (props.open ? "flex" : "none")};
	flex-direction: column;
	z-index: 9999;

	.modal-item {
		${commonModalItemStyles}
		max-height: 75vh;
		width: 100%;
	}

	${({ position }) =>
		position === "centered" &&
		css`
			justify-content: center;

			${ModalContent} {
				@media (max-width: 768px) {
					justify-content: center;
				}
			}
		`}

	${({ position }) =>
		position === "top" &&
		css`
			padding-top: 60px;

			@media (min-width: 1024px) {
				padding-top: 90px;
			}
		`}
`;

export const ModalOverlay = styled.div`
	position: fixed;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
	background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
		linear-gradient(0deg, rgba(255, 128, 47, 0.2) 0%, rgba(255, 128, 47, 0.2) 100%),
		linear-gradient(0deg, rgba(26, 27, 43, 0.6) 0%, rgba(26, 27, 43, 0.6) 100%),
		radial-gradient(50% 50% at 50% 50%, rgba(80, 46, 128, 0.07) 0%, rgba(0, 0, 0, 0.9) 100%);
	background-blend-mode: normal, color, normal, normal;
	backdrop-filter: blur(12.5px);
	${commonAnimationStyles}
`;

export const ModalContent = styled.div`
	${commonFlexStyles}

	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	padding: 20px 18px;
	border-radius: 4px;
	position: relative;
	width: 100%;
	height: 100%;

	${commonAnimationStyles}

	@media (min-width: 375px) {
		padding: 20px;
	}

	${({ hasOverflow }) =>
		hasOverflow &&
		css`
			overflow-y: auto;

			@media (min-width: 1024px) {
				overflow-y: hidden;
				width: 100%;
			}

			.modal-item {
				@media (min-width: 1024px) {
					width: 100%;
					padding: 0 50px;
					align-content: space-between;
					align-items: center;
				}
			}
		`}

	${({ isPaymentPage }) =>
		isPaymentPage &&
		css`
			margin-top: -20px;
		`}
`;

export const ModalHeader = styled.div`
	${commonFlexStyles}
	justify-content: center;
	color: var(--secondary-text-color);
	text-align: center;
	font-size: 16px;
	font-weight: 700;
	line-height: 20px;
	letter-spacing: 0.75px;
	margin-bottom: 20px;
`;
